import { Button, CustomClaimValue, Icons, useAuth } from "@app/shared";
import { PropsWithChildren, useMemo, useState } from "react";
import { useSessionStorage } from "react-use";
import { NoAuthAccountLayout } from "../layouts";


export const AdminNagScreen = (props: PropsWithChildren) => {
    const auth = useAuth();
    const [nagHasPrompted, setNagHasPrompted] = useSessionStorage('nagHasPrompted', false);
    const [message, setMessage] = useState("");
    const isSuperAdmin = auth.userClaims?.find(uc => uc.claims.find(c => c === CustomClaimValue.SuperAdmin));

    const showAdminNagBorder = useMemo(() => {
        if (auth?.isInMaintenanceMode) {
            setMessage("Maintenance Mode");
            return true;
        }
        if (auth.userClaims?.find(uc => uc.claims.find(c => c === 5)) === null) {
            setMessage('');
            return false;
        }
        if (auth.user?.email !== 'admin@omnisightusa.com') {
            setMessage('');
            return false;
        }
        if (auth.user) {
            if (!nagHasPrompted && process.env.NODE_ENV === 'production') {
                alert('Please log in as a named user instead of the admin account');
                setNagHasPrompted(true);
                setMessage('Log in as named user');
                return true;
            }
        }
        setMessage('');
        return false;

    }, [auth.userClaims, auth.user, nagHasPrompted, setNagHasPrompted, auth.isInMaintenanceMode]);

    return (
        <>
            {(showAdminNagBorder && isSuperAdmin) && <>
                <div className="border-[18px] border-[#ff0000] w-screen h-screen">
                    {props.children}
                </div>
                <span className="absolute top-0 left-1/2 -translate-x-1/2 text-xs text-[#000000] whitespace-nowrap">
                    {[...Array(20)].map((_, index) => (
                        <span key={index} className="me-5 font-semibold">{message}</span>
                    ))}
                </span>

                <span className="absolute bottom-0 left-1/2 -translate-x-1/2 text-xs text-[#000000]  whitespace-nowrap">
                    {[...Array(20)].map((_, index) => (
                        <span key={index} className="me-5 font-semibold">{message}</span>
                    ))}
                </span>

                <span className="absolute left-2 top-1/2 -translate-y-1/2 -rotate-90 origin-left text-xs text-[#000000] whitespace-nowrap">
                    <span className="font-semibold">{message}</span>
                </span>

                <span className="absolute right-2 top-1/2 -translate-y-1/2 rotate-90 origin-right text-xs text-[#000000] whitespace-nowrap">
                    <span className="font-semibold">{message}</span>
                </span>
            </>}
            {(auth.isInMaintenanceMode && !isSuperAdmin) && <NoAuthAccountLayout>
                <div className="flex place-items-center gap-5">
                    <Icons.AlertTriangle size={100} />
                    <div>
                        <h2>Update in Progress</h2>
                        <p className="pt-5">The system is currently being updated.  Please try back soon.</p>
                    </div>
                </div>
                <div className="flex place-items-center justify-center">
                    <Button onClick={()=>window.location.assign('/')}>Refresh</Button>
                </div>
            </NoAuthAccountLayout>}
            {(!showAdminNagBorder || !isSuperAdmin) && !!!auth?.isInMaintenanceMode && props.children}

        </>
    );
}